import { createContext } from 'react';
import type { ThemeFamilyId, ThemeSelection } from '@/lib/theme/themeRegistry';

export interface ThemeContextType {
  theme: ThemeSelection;
  setTheme: (theme: ThemeSelection) => void;
  themeFamilyId: ThemeFamilyId;
  setThemeFamilyId: (themeFamilyId: ThemeFamilyId) => void;
  resolvedTheme: 'light' | 'dark';
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
